// extracted by mini-css-extract-plugin
export default {"imgWrapperDiv":"ImgComponent_imgWrapperDiv__jIFqn","blurred":"ImgComponent_blurred__FAN1J"};